import { RootId } from '../../constants/MediaFromWixCategory';
import { WixMediaRoot } from '../../constants/WixMediaRoot';
import ImagesImage from './DiscoverMediaTypesSection/assets/group-copy-36@3x.png';
import IllustrationsImage from './DiscoverMediaTypesSection/assets/group-copy-37@3x.png';
import VectorArtImage from './DiscoverMediaTypesSection/assets/group-copy-38@3x.png';
import BasicShapesImage from './DiscoverMediaTypesSection/assets/group-copy-39@3x.png';
import VideosImage from './DiscoverMediaTypesSection/assets/group-copy-40@3x.png';
import TransparentVideosImage from './DiscoverMediaTypesSection/assets/group-copy-41@3x.png';

export const discoverMediaTypesSettings = [
  {
    image: ImagesImage,
    translationKey: 'media-home.discover-media-types.images',
    root: WixMediaRoot.Images,
    rootId: RootId.Images,
  },
  {
    image: IllustrationsImage,
    translationKey: 'media-home.discover-media-types.illustrations',
    root: WixMediaRoot.Illustrations,
    rootId: RootId.Illustrations,
  },
  {
    image: VectorArtImage,
    translationKey: 'media-home.discover-media-types.vector-art',
    root: WixMediaRoot.VectorArtNew,
    rootId: RootId.VectorArtNew,
  },
  {
    image: BasicShapesImage,
    translationKey: 'media-home.discover-media-types.basic-shapes',
    root: WixMediaRoot.BasicShapes,
    rootId: RootId.BasicShapes,
  },
  {
    image: VideosImage,
    translationKey: 'media-home.discover-media-types.videos',
    root: WixMediaRoot.Videos,
    rootId: RootId.Videos,
  },
  {
    image: TransparentVideosImage,
    translationKey: 'media-home.discover-media-types.transparent-videos',
    root: WixMediaRoot.TransparentVideos,
    rootId: RootId.TransparentVideos,
  },
];
